import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { CommonServices } from "src/app/common.services";

@Component({
  selector: "app-admin-trips-cancel",
  templateUrl: "./admin-trips-cancel.component.html",
  styleUrls: ["./admin-trips-cancel.component.css"],
})
export class AdminTripsCancelComponent implements OnInit {
  token: any;

  loading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminTripsCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router,
    private commonService: CommonServices
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
  }
  cancelTrip() {
    this.loading = true;
    this.services.tripCancel(this.data._id, this.token).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status == 200) {
          this.commonService.publishMessage("tripAssigned", response.body.data);

          this.snackBar.open("Trip has been completed", "Success", {
            duration: 5000,
          });
          this.matdialogref.close(true);
        }
      },
      (error) => {
        this.loading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  cancel() {
    this.matdialogref.close();
  }
}
